import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { EditWorkoutAsync, GetInstructorAsync, GetSingleWorkoutSecuredAsync, GetWorkoutTypesAsync, selectEditFlag, selectInstructorList, selectSingleWorkout, selectWorkoutTypesList, setEditFlag } from '../features/add_workout/workoutSlice';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Checkbox, FormControlLabel, MenuItem, TextField } from '@mui/material';
import styles from './style/editWorkout.module.css'
import CustomTextField from './CustomTextField';
import { useConfirm } from './AlertDialogModal';

const EditWorkout = () => {
    const editFlag = useAppSelector(selectEditFlag);
    const currentWorkout = useAppSelector(selectSingleWorkout);
    const instructors = useAppSelector(selectInstructorList);
    const workoutTypes = useAppSelector(selectWorkoutTypesList);
    const dispatch = useAppDispatch();
    let WorkoutId = useParams().workoutId;
    const [workoutDate, setDate] = useState("");
    const [workoutTime, setTime] = useState("");
    const [WorkoutLocation, setWorkoutLocation] = useState("");
    const [Instructor, setInstructor] = useState("")
    const [MaximumParticipants, setMaximumParticipants] = useState(0);
    const [Notes, setNotes] = useState("");
    const [Terms, setTerms] = useState("");
    const [Type, setType] = useState("")
    const [FullForm, setFullForm] = useState(false);
    const [IsActive, setIsActive] = useState(true);
    const [hold, setHold] = useState(true)
    const [price, setPrice] = useState(0)

    const confirm = useConfirm()

    useEffect(() => {
        dispatch(GetWorkoutTypesAsync()).unwrap().catch((err) => console.error("Handled error:", err));
        dispatch(GetInstructorAsync()).unwrap().catch((err) => console.error("Handled error:", err));
        dispatch(GetSingleWorkoutSecuredAsync(WorkoutId as string)).unwrap().catch((err) => console.error("Handled error:", err));
        // eslint-disable-next-line
    }, [editFlag])


    useEffect(() => {
        if (currentWorkout) {
            setVariables();
            setTimeout(() => {
                setHold(false)
            }, 250);
        }
        // eslint-disable-next-line
    }, [currentWorkout]);

    const setVariables = () => {
        setDate(currentWorkout?.date === undefined ? "" : currentWorkout?.date)
        setTime(currentWorkout?.time === undefined ? "" : currentWorkout?.time)
        setWorkoutLocation(currentWorkout?.location === undefined ? "" : currentWorkout?.location)
        setInstructor(currentWorkout?.instructor?.id === undefined ? "" : currentWorkout?.instructor?.id)
        setMaximumParticipants(currentWorkout?.maximumParticipants === undefined ? 0 : currentWorkout?.maximumParticipants)
        setNotes((currentWorkout?.notes === undefined || currentWorkout?.notes === null) ? "" : currentWorkout?.notes)
        setTerms((currentWorkout?.terms === undefined || currentWorkout?.terms === null) ? "" : currentWorkout?.terms)
        setType(currentWorkout?.type?.id === undefined ? "" : currentWorkout?.type?.id)
        setFullForm(currentWorkout?.fullForm === undefined ? false : currentWorkout?.fullForm)
        setIsActive(currentWorkout?.isActive === undefined ? false : currentWorkout?.isActive)
        setPrice(currentWorkout?.price === undefined ? 0 : currentWorkout?.price)

    }

    const restVariables = () => {
        setDate("")
        setTime("")
        setWorkoutLocation("")
        setInstructor("")
        setMaximumParticipants(0)
        setNotes("")
        setTerms("")
        setType("")
        setFullForm(false)
        setIsActive(true)
    }

    const handleSuccess = () => {
        restVariables();
        toast.success("האימון התעדכן בהצלחה!");
        dispatch(setEditFlag());
    }

    const handleSubmit = async () => {

        const handleConfirmation = async (title:string,content:string) => {
            const isConfirmed = await confirm({
            title: title,
            content: content,
            });
            return isConfirmed
        }

        let noErrors = document.querySelector<HTMLInputElement>('form[id="editWorkout"]')?.checkValidity();

        if (noErrors) {
            if (currentWorkout.isActive === true && IsActive === false) {
                let title = "ביטול אימון"
                let content = `שים לב!\nפעולה זו תגרור ביטול של האימון\n${currentWorkout.currentParticipantsCount > 0 ? `הודעת ביטול תישלח בדואר אלקטרוני ל- ${currentWorkout?.currentParticipantsCount} משתתפים` : "לא רשומים לאימון זה משתתפים"}`
                const isConfirmed = await handleConfirmation(title,content)
                if (!isConfirmed) {
                    toast.error("הפעולה בוטלה - האימון לא עודכן");
                    return
                }
            }
            dispatch(EditWorkoutAsync({ id: (`${WorkoutId}`), workout: { 'date': workoutDate, 'time': workoutTime, "instructorId": Instructor, "location": WorkoutLocation, "typeId": Type, "maximumParticipants": MaximumParticipants, "notes": Notes, "terms": Terms, "fullForm": FullForm, "isActive": IsActive , "price": price} })).unwrap()
                .then(handleSuccess)
                .catch((err) => {
                    toast.error("אירעה שגיאה");
                })
        }
        else
            toast.error("קיימת טעות בטופס, אנא וודא את הפרטים שמולאו");
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', }}>
            {hold ?
                <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
                :
                <form id='editWorkout' method='post' onSubmit={(e) => e.preventDefault()} noValidate>
                    <h1>עריכת אימון</h1>
                    <div className={styles.formGrid}>
                        <TextField className={styles.div1} variant="filled" label='תאריך האימון' type='date' value={workoutDate} onChange={(e) => setDate(e.target.value)} required slotProps={{inputLabel:{ shrink: true } }} />
                        <TextField className={styles.div2} variant="filled" label='שעת האימון' type='time' value={workoutTime} onChange={(e) => setTime(e.target.value)} required slotProps={{inputLabel:{ shrink: true } }} />
                        <TextField className={styles.div3} variant="filled" label='מיקום האימון' type='text' value={WorkoutLocation} onChange={(e) => setWorkoutLocation(e.target.value)} required />                
                        <TextField className={styles.div4} variant="filled" label='מדריך האימון' select onChange={(e) => setInstructor(e.target.value)} required value={Instructor === "" ? "" : Instructor}>
                            {instructors !== undefined && instructors.map((value, index) => <MenuItem key={index} value={value.id}>{value.fullName}</MenuItem>)}
                        </TextField>
                        <TextField className={styles.div5} variant="filled" label='סוג האימון' select onChange={(e) => setType(e.target.value)} required value={Type === '' ? '' : Type}>
                            {workoutTypes !== undefined && workoutTypes.map((value, index) => <MenuItem key={index} value={value.id}>{value.name}</MenuItem>)}
                        </TextField>
                        <TextField className={styles.div6} variant="filled" label='כמות מקסימלית של משתתפים באימון' type='number' value={MaximumParticipants === undefined ? "" : MaximumParticipants} onChange={(e) => setMaximumParticipants(+e.target.value)} required />
                        <CustomTextField className={styles.div7} variant="filled" label='הערות' type='text' value={Notes} onChange={(e) => setNotes(e.target.value)}  slotProps={{ htmlInput: { maxLength: 256 } }} counter/>
                        <CustomTextField className={styles.div8} variant="filled" label='תנאים' value={Terms} multiline rows={10} type='text' onChange={(e) => setTerms(e.target.value)} style={{ height: '100%' }} slotProps={{ htmlInput: { maxLength: 1001 } }} counter/>
                        <CustomTextField className={styles.div9} variant="filled" label='מחיר' type='number' value={price === undefined ? 0 : price} onChange={(e) => setPrice(+e.target.value)} required slotProps={{ htmlInput: { min: 0 } }}/>
                        <FormControlLabel className={styles.div10}
                            control={<Checkbox checked={!!FullForm} onChange={() => setFullForm(!FullForm)} />}
                            label="טופס הרשמה מלא"
                            labelPlacement="end"
                        />
                        <FormControlLabel className={styles.div12}
                            control={<Checkbox checked={!! !IsActive} onChange={() => setIsActive(!IsActive)} />}
                            label="אימון מבוטל?"
                            labelPlacement="end"
                        />
                        <div className={styles.div11} style={{}}>
                            <Button type='submit' onClick={() => handleSubmit()} variant="contained" color='success' size='large'>עדכן אימון</Button><br/><br/>
                            <div style={{ display: 'flex', gap: '10px', justifyContent:'center', alignItems: 'center', }}>
                                <Button variant='contained' color='secondary' size='large' ><Link to={`/manageWorkout/participants/${WorkoutId}`} state={{ instructors: instructors, workoutTypes: workoutTypes }} style={{ color: 'white' }}>צפה ברשימת המתאמנים</Link></Button>
                                {/* &emsp; */}
                                <Button variant='contained' color='warning' size='large' ><Link to={'/manageWorkout'} style={{ color: 'white' }}>חזור לרשימת האימונים</Link></Button>
                            </div>
                        </div>
                    </div>
                </form>
            }

        </div>
    )
}

export default EditWorkout